const Constent = {
    PAGINATION_SIZE : 20,
    DEBOUNCE_DELAY : 500,
    DATE_FORMAT : 'MM-dd-yyyy',
    PRINT_INVOICE_PERIOD_START_DATE_FORMAT : 'LLLL do',
    PRINT_INVOICE_PERIOD_END_DATE_FORMAT : 'LLLL do yyyy'
}

Object.freeze(Constent);

export default Constent;